import React from "react";
import Logo from "./Logo.js";

export default ({link, variant}) => <Logo inline={true} noLink={!link} variant={(variant || "inherit")} />;
